var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isHotel
        ? _c("div", { staticClass: "bp-box is-info" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("main", [
              _c("div", { staticClass: "is-one-row" }, [
                _c(
                  "div",
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("date_range"),
                    ]),
                    _vm._v(" Menü für den\n                        "),
                    _c("multiselect", {
                      staticClass: "is-shorter mr-1",
                      staticStyle: { width: "100px" },
                      attrs: { options: _vm.dates },
                      model: {
                        value: _vm.date,
                        callback: function ($$v) {
                          _vm.date = $$v
                        },
                        expression: "date",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("access_time"),
                    ]),
                    _vm._v(" "),
                    _c("multiselect", {
                      staticClass: "is-shorter mr-1",
                      staticStyle: { width: "120px" },
                      attrs: { options: _vm.subTypeOptions },
                      model: {
                        value: _vm.subType,
                        callback: function ($$v) {
                          _vm.subType = $$v
                        },
                        expression: "subType",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "buttons has-addons mb-1" }, [
        !_vm.isHotel && _vm.otherServiceTypeId
          ? _c(
              "button",
              {
                staticClass: "button is-small",
                class: _vm.filterByServiceType ? "is-active" : "",
                attrs: {
                  title:
                    "Menüs nach " +
                    _vm.otherServiceTypeName +
                    " filtern (blau = Filter aktiv)",
                },
                on: {
                  click: function ($event) {
                    _vm.filterByServiceType = !_vm.filterByServiceType
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("filter_list"),
                ]),
                _vm._v("Leistung"),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.request.startAt || _vm.request.endAt
          ? _c(
              "button",
              {
                staticClass: "button is-small",
                class: _vm.filterByDate ? "is-active" : "",
                attrs: {
                  title:
                    "Nur Menüs anzeigen, die für das Leistungsdatum gültig sind",
                },
                on: {
                  click: function ($event) {
                    _vm.filterByDate = !_vm.filterByDate
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [
                  _vm._v("filter_list"),
                ]),
                _vm._v("Zeitraum"),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      !_vm.loaded ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _vm.loaded && (!_vm.isHotel || (_vm.date && _vm.subType))
        ? _c(
            "div",
            { staticClass: "columns is-multiline" },
            [
              _vm._l(_vm.menus, function (menu) {
                return _c(
                  "div",
                  {
                    key: menu.id,
                    staticClass:
                      "column is-full-mobile is-half-tablet is-one-third-desktop is-one-quarter-widescreen is-flex",
                  },
                  [
                    _c("div", { staticClass: "bp-panel pt-3 is-flex-grow" }, [
                      _c("div", { staticClass: "panel-content" }, [
                        !_vm.isHotel &&
                        !_vm.filterByServiceType &&
                        menu.otherService &&
                        menu.otherService.otherServiceType &&
                        menu.otherService.otherServiceType.id !==
                          _vm.otherServiceTypeId
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "content has-text-danger is-size-7 mb-2",
                              },
                              [
                                _c(
                                  "i",
                                  {
                                    staticClass: "material-icons",
                                    staticStyle: {
                                      "font-size": "14px",
                                      "vertical-align": "middle",
                                    },
                                  },
                                  [_vm._v("warning")]
                                ),
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      menu.otherService.otherServiceType.name
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "content mb-2" }, [
                          _vm.toggleRadioButton(menu)
                            ? _c("label", { staticClass: "radio" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.checked,
                                      expression: "checked",
                                    },
                                  ],
                                  staticClass: "ml-0",
                                  attrs: { type: "radio" },
                                  domProps: {
                                    value: menu,
                                    checked: _vm._q(_vm.checked, menu),
                                  },
                                  on: {
                                    change: [
                                      function ($event) {
                                        _vm.checked = menu
                                      },
                                      function ($event) {
                                        return _vm.check(menu)
                                      },
                                    ],
                                  },
                                }),
                                _vm._v(
                                  "\n                                Menü auswählen\n                            "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.toggleLabel(menu)
                            ? _c(
                                "label",
                                { staticClass: "tag is-primary mr-2 ml-0" },
                                [_vm._v("Ausgewählt")]
                              )
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "content mb-0" }, [
                          _c("div", { staticClass: "level" }, [
                            _c("strong", { staticClass: "level-left" }, [
                              _vm._v(_vm._s(menu.title)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "level-right" }, [
                              _c("span", {
                                staticClass: "has-text-right",
                                domProps: {
                                  innerHTML: _vm._s(_vm.price(menu)),
                                },
                              }),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "content mb-0" }, [
                          _c("div", { staticClass: "level" }, [
                            _c(
                              "div",
                              { staticClass: "level-left is-small-text" },
                              [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.dateLabel(menu)) +
                                    "\n                                "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "nl2br content mt-2",
                          domProps: { innerHTML: _vm._s(menu.content) },
                        }),
                      ]),
                    ]),
                  ]
                )
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  key: "add",
                  staticClass:
                    "column is-full-mobile is-half-tablet is-one-third-desktop is-one-quarter-widescreen is-flex",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "bp-panel is-add",
                      staticStyle: { "min-height": "100px" },
                      on: { click: _vm.openForm },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("add"),
                      ]),
                    ]
                  ),
                ]
              ),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("menu-form", {
        ref: "form",
        staticClass: "menu-form",
        attrs: {
          "options-array": _vm.$store.state.options,
          provider: _vm.request.provider,
        },
        on: { updateMenus: _vm.updateMenus },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", [
      _c("i", { staticClass: "material-icons" }, [_vm._v("restaurant")]),
      _vm._v(" Menüauswahl\n            "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }